import { Button, Form, Modal, Space } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import IApplication from '~Api/Application/IApplication';
import IApplicationProperty from '~Api/Application/IApplicationProperty';
import { applicationPropertyValuationInspectionDateAction } from '~Applications/actions';
import DatePicker from '~UI/DatePicker';
import { IDictionary } from '~utilities/IDictionary';

interface IDefaultedValues {
    valuationInspectionDate: string;
}

interface IState {
    dirtyFields: IDictionary<boolean>;
    valuationInspectionDate: string;
}

interface IProps {
    application: IApplication;
    applicationProperty: IApplicationProperty;
    isOpen: boolean;
    onCancel: () => void;
}

interface IPropsDispatch {
    applicationPropertyValuationInspectionDate: (valuationInspectionDate: string) => void;
}

type Props = IProps & IPropsDispatch;

class ValuationInspectionDateModal extends React.Component<Props, IState> {
    public state: IState = {
        dirtyFields: {},
        valuationInspectionDate: null,
    };

    constructor(props: Props) {
        super(props);

        this.getDefaultedValues = this.getDefaultedValues.bind(this);

        this.onClickOk = this.onClickOk.bind(this);
        this.onClickClear = this.onClickClear.bind(this);
        this.onChangeValuationInspectionDate = this.onChangeValuationInspectionDate.bind(this);
    }

    public render(): JSX.Element {
        const { isOpen, onCancel } = this.props;
        const { valuationInspectionDate } = this.getDefaultedValues();

        const valuationInspectionDateDayJs: Dayjs = valuationInspectionDate ? dayjs(valuationInspectionDate) : null;

        return (
            <Modal
                okText='Update'
                onCancel={onCancel}
                onOk={this.onClickOk}
                open={isOpen}
                title='Valuation Inspection Date'
                wrapClassName='property-valuation-inspection-date-modal'
            >
                <Form.Item className='valuation-inspection-date' label='Inspection Date'>
                    <Space>
                        <DatePicker onChange={this.onChangeValuationInspectionDate} value={valuationInspectionDateDayJs} format='DD/MM/YYYY' />
                        <Button onClick={this.onClickClear}>Clear</Button>
                    </Space>
                </Form.Item>
            </Modal>
        );
    }

    private getDefaultedValues(): IDefaultedValues {
        const { applicationProperty } = this.props;
        const { dirtyFields, valuationInspectionDate } = this.state;

        return {
            valuationInspectionDate: dirtyFields.valuationInspectionDate ? valuationInspectionDate : applicationProperty.valuationInspectionDate,
        };
    }

    private onChangeValuationInspectionDate(date: Dayjs) {
        const { dirtyFields, valuationInspectionDate } = this.state;

        this.setState({
            dirtyFields: {
                ...dirtyFields,
                valuationInspectionDate: true,
            },
            valuationInspectionDate: dayjs(`${date.format('YYYY-MM-DD')} ${dayjs(valuationInspectionDate || undefined).format('HH:mm')}`).format(),
        });
    }

    private onClickClear() {
        const { dirtyFields } = this.state;

        this.setState({
            dirtyFields: {
                ...dirtyFields,
                valuationInspectionDate: true,
            },
            valuationInspectionDate: null,
        });
    }

    private onClickOk() {
        const { valuationInspectionDate } = this.getDefaultedValues();

        this.props.applicationPropertyValuationInspectionDate(valuationInspectionDate);
        this.props.onCancel();
    }
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: IProps): IPropsDispatch {
    return {
        applicationPropertyValuationInspectionDate: (valuationInspectionDate: string) => dispatch(applicationPropertyValuationInspectionDateAction(ownProps.applicationProperty.uuid, valuationInspectionDate)),
    };
}

export default connect(
    null,
    mapDispatchToProps,
)(ValuationInspectionDateModal);
